
// Changes to layout when on mobile devices
function ChartChanges() {
	
	// Charts
	if( $(window).width() < 920 ) {
		
	 	$('.gvchart .chartdata').css({'overflow': 'hidden', 'width' : '100%'});
		$('#gvChartDiv1').css({'width' : '100%'});		
		$('.gvchart #gvChartDiv1').children('div').css('width', '100%');
		
	}
}

function MenuPanel() {
	
	$('#mobile-nav').click(function() {
		$('#menu ul.topmenu').toggle();
	});
	
}

// Accordian style nav for small mobile devices 
function AccordianMainNav() {

		// Hide subnavs
		var allContents = $('#menu .topmenu .subnav');
		$(allContents).hide();
		
		$('#menu .topmenu a').click(function(event) {
			
			// Only prevent default link if its a parent of section not straight link (eg home, contact)
			if( $(window).width() < 1100 && $(this).siblings('.subnav').length > 0 ) {

				event.preventDefault();
				
				// close all panels
				allContents.slideUp();
				
				if( $(this).next('.subnav').is(':visible') ) {
				
					// close clicked panel
					$(this).next('.subnav').slideUp();
					
				} else {
				
					// open clicked panel
					$(this).next('.subnav').slideDown();
				
					// add .on class
					$(this).addClass('open');
				
				}
			}
		});

	$(window).resize(function() {

    	if($(window).width() > 1100 ) {
    		// Hide subnavs
			$('#menu ul.topmenu').show();
			$('#menu .topmenu .subnav').hide();
    	}
	});
}

function SearchBar() {
	// Hide/show bar
	$('.search-link a').click( function() {	
		if( $(this).hasClass('show') ) {			
			// Show bar
			$('.search').animate({'right' : '-210px' }, 500);
			$(this).removeClass('show');
			return false;
			
		} else {		
			// Hide bar
			$('.search').animate({'right' : '40px' }, 500);
			$(this).addClass('show');
			return false;
			
		}		
	});
}

function ToggleContent(){
    $('.toggle-button').click(function(e){
        $(this).parent('.togglable').children('.togglable-content').slideToggle(200);
        $(this).toggleClass('open');
        if( $(this).hasClass('fa-caret-down') ){
        	$(this).removeClass('fa-caret-down').addClass('fa-caret-up');
        }else{
        	$(this).removeClass('fa-caret-up').addClass('fa-caret-down');
        }
    });
}

function doLoaderMessage() {
	$('.loader:not(.loader--ajax)').fadeOut(600);
			
	// wait 1.5 seconds, then fade out the global messages
	$('.message').delay(2000).fadeOut(200);
}

$(document).ready(function(){

	if(document.readyState === 'complete') {
    	doLoaderMessage();
	} else {
		document.addEventListener('readystatechange', function(){
	    	if(document.readyState === 'complete')
	        	doLoaderMessage();
	        }
	)};
	
	SearchBar();
	ChartChanges();
	ToggleContent();
	
	// Listen for window resize
	$(window).resize(function() {		
		if( $('.gvchart').length > 0 ) {
			location.reload(true);
		}	
	});	
});